/**
 * PDF全文検索コントロール
 *
 * 検索入力・検索ボタン・件数表示・前へ/次へボタンを提供する。
 * 表示コンテキスト（デスクトップインライン・モバイルアコーディオン）は呼び出し元が制御する。
 *
 * サブコンポーネント:
 *   PdfSearchPanel.Trigger — モバイル用トグルボタン（虫眼鏡）
 */

const SearchIcon = () => (
  <svg
    className="pdf-search-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PrevIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const NextIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const PdfSearchPanel = ({
  searchText,
  onSearchTextChange,
  searchResults,
  currentSearchIndex,
  isSearching,
  onSearch,
  onNextSearchResult,
  onPrevSearchResult,
  onClearSearch,
  pdfDocument,
  searchError,
}) => {
  return (
    <div>
      <div className="pdf-search-panel-row">
        <div className="pdf-search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            className="pdf-search-input"
            placeholder="検索ワードを入力..."
            value={searchText}
            onChange={(e) => onSearchTextChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            disabled={isSearching || !pdfDocument}
          />
          {searchText && (
            <button className="pdf-search-clear-btn" onClick={onClearSearch} title="クリア">
              ×
            </button>
          )}
        </div>
        <button
          className="pdf-search-btn"
          onClick={onSearch}
          disabled={isSearching || !pdfDocument || !searchText.trim()}
        >
          {isSearching ? '...' : '検索'}
        </button>
        <>
          <span className="pdf-search-count">
            {searchResults.length > 0 ? `${currentSearchIndex + 1}/${searchResults.length}` : '0/0'}
          </span>
          <button
            className="pdf-search-nav-btn"
            onClick={onPrevSearchResult}
            disabled={searchResults.length === 0 || isSearching}
          >
            <PrevIcon />
          </button>
          <button
            className="pdf-search-nav-btn"
            onClick={onNextSearchResult}
            disabled={searchResults.length === 0 || isSearching}
          >
            <NextIcon />
          </button>
        </>
      </div>
      {searchError && (
        <div className="pdf-search-error-text">{searchError}</div>
      )}
    </div>
  );
};

const PdfSearchPanelTrigger = ({ isSearchOpen, onToggleSearchOpen }) => (
  <button
    className={`pdf-search-toggle-btn${isSearchOpen ? ' active' : ''}`}
    onClick={onToggleSearchOpen}
    title={isSearchOpen ? '検索を閉じる' : '検索を開く'}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  </button>
);

PdfSearchPanel.Trigger = PdfSearchPanelTrigger;

export default PdfSearchPanel;
